/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const StateMessageWrapper = styled.div({
  marginBottom: `${token('space.150')}`,
});

export const StateMessageErrorWrapper = styled.div({
  whiteSpace: 'pre-wrap',
});
